// Only one item MUST have the "default: true" key

module.exports = {
  en: {
    default: true,
    path: `en`,
    locale: `en-US`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `en`,
    ogLanguage: `en_US`,
    defaultTitle: `Eder Munhoz Santos`,
    defaultDescription: `A blog about personal content and front end experiences`
  },
  pt: {
    path: `pt`,
    locale: `pt-BR`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `pt`,
    ogLanguage: `pt_BR`,
    defaultTitle: `Eder Munhoz Santos`,
    defaultDescription: `Um blog sobre conteúdo pessoal e experiências front end`
  }
}
